import {renderPhoneNumber} from "../../utils/renderPhoneNumber";
import * as React from "react";
import {DateLastChanged} from "./date-last-changed";

interface IProps {
    contactInfo: any;
    className: string;
}

export function ContactDetails ({contactInfo, className}: IProps) {
    if (!contactInfo) return null;
    return <div className={className}>
        <div><b>Contact Id</b>: {contactInfo.pocid}</div>
        <div><b>Name</b>: {contactInfo.name}</div>
        <div><b>Cell</b>: {renderPhoneNumber(contactInfo.cell)}</div>
        {/*<div><b>Land</b>: {renderPhoneNumber(contactInfo.land)}</div>*/}
        <div><b>Email</b>: {contactInfo.email}</div>
        <div><b>Edited By</b>: {contactInfo.pubconinfo}</div>
        {/*<div><b>Instructions</b>: {contactInfo.instruc}</div>*/}
        <div>
            <DateLastChanged date={contactInfo.datelastchanged}/>
        </div>
    </div>;
}